const observedRoots = new WeakMap();
const measuredTracks = new WeakSet();
let cancelPendingWrite;

// Enhance the anchor only with the provider's own initialized button/form.
// The normal #reviews navigation also triggers Judge.me's lazy loading.
function openReviewForm(root) {
  cancelPendingWrite?.();
  const observer = new MutationObserver(tryOpen);
  const timeout = window.setTimeout(cleanup, 10000);

  function cleanup() {
    observer.disconnect();
    window.clearTimeout(timeout);
    if (cancelPendingWrite === cleanup) cancelPendingWrite = undefined;
  }

  function tryOpen() {
    if (!root.isConnected) return cleanup();
    const button = root.querySelector('.jdgm-write-rev-link[aria-expanded]');
    const field = root.querySelector('.jdgm-form-wrapper [role="radio"][tabindex="0"]');
    // The lazy widget exposes its button before its form has finished setup.
    if (!button?.getClientRects().length || !field) return;
    // Clicking an already-open native button would close the form.
    if (button.getAttribute('aria-expanded') !== 'true') button.click();

    if (field?.getClientRects().length) {
      cleanup();
      field.focus();
    }
  }

  cancelPendingWrite = cleanup;
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded', 'style', 'class'],
  });
  tryOpen();
}

document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-tcs-write-review]');
  if (
    !link ||
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return;
  const root = document.querySelector('#reviews.tcs-reviews--source-app');
  if (root) {
    // Run after the anchor's default scroll, so focusing does not get undone.
    requestAnimationFrame(() => openReviewForm(root));
  }
});

function dispatchResize(root) {
  if (!root.isConnected) return;
  window.dispatchEvent(new Event('resize'));
}

function remeasureNewCarousels(root) {
  const tracks = root.querySelectorAll('.jdgm-rev-carousel .jdgm-glider-track');

  tracks.forEach((track) => {
    if (measuredTracks.has(track)) return;
    measuredTracks.add(track);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => dispatchResize(root));
    });
    window.setTimeout(() => dispatchResize(root), 250);
    document.fonts?.ready.then(() => dispatchResize(root));
  });
}

function observeReviews(root) {
  if (observedRoots.has(root)) return;

  const observer = new MutationObserver(() => remeasureNewCarousels(root));
  observer.observe(root, { childList: true, subtree: true });
  observedRoots.set(root, observer);
  remeasureNewCarousels(root);
}

function initializeReviews(scope = document) {
  if (scope.matches?.('.tcs-reviews--source-app')) observeReviews(scope);
  scope.querySelectorAll?.('.tcs-reviews--source-app').forEach(observeReviews);
}

initializeReviews();

document.addEventListener('shopify:section:load', (event) => initializeReviews(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  cancelPendingWrite?.();
  const root = event.target.matches?.('.tcs-reviews--source-app')
    ? event.target
    : event.target.querySelector?.('.tcs-reviews--source-app');
  const observer = root && observedRoots.get(root);

  observer?.disconnect();
  if (root) observedRoots.delete(root);
});
